import logo from "../images/logohalliLabs.svg";
import cert from "../images/RegistrationCertificate.jpg";
import Vivekananda from "../images/SwamiVivekananda.jpeg";

const images = {
    logo,
    cert,
    Vivekananda,
  };
  export default images;